import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageProvider';

const useLanguage = () => {
  const { language = 'en', setLanguage } = useContext(LanguageContext) || {};
  return { language, setLanguage };
};

export default useLanguage;
